import { SET_INSPECTIONS } from "../../constants";

export const inspections = (state: any = null, action: any) => {
  switch (action.type) {
    case SET_INSPECTIONS:
      return action.payload;
    default:
      return state;
  }
};